import React from 'react';
import {
  hasNearMissNameMerge,
  hasValidNameMerge,
  splitMergeTagSegments,
} from '../../utils/merge-tags';

/**
 * Renders message text with valid merge tokens as highlighted chips.
 */
export default function MergeTagPreview({
  text,
  includeGmb = false,
  className = '',
  showHints = true,
}) {
  const segments = splitMergeTagSegments(text, { includeGmb });
  const validName = hasValidNameMerge(text);
  const nearMiss = !validName && hasNearMissNameMerge(text);

  return (
    <div className={className}>
      <p className="text-foreground whitespace-pre-wrap break-words">
        {segments.map((seg, i) => {
          if (seg.type === 'token') {
            const chipClass =
              seg.kind === 'gmb'
                ? 'bg-amber-100 text-amber-900 border-amber-200'
                : 'bg-primary/15 text-primary border-primary/25';
            return (
              <span
                key={`${i}-${seg.value}`}
                className={`inline-flex items-center px-1.5 py-0.5 mx-0.5 rounded border text-[0.85em] font-mono align-baseline ${chipClass}`}
              >
                {seg.value}
              </span>
            );
          }
          return <React.Fragment key={i}>{seg.value}</React.Fragment>;
        })}
      </p>
      {showHints && validName && (
        <p className="text-xs text-muted-foreground mt-1.5">
          First name will be filled in at send time.
        </p>
      )}
      {showHints && nearMiss && (
        <p className="text-xs text-amber-700 mt-1.5">
          That name tag will not be recognized. Use Field Merges → First Name so the tag is correct.
        </p>
      )}
    </div>
  );
}
